<template>
  <section>
    <section-header :current="current" />
    <matricula :current="current" :auto="auto"/>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import Matricula from '@/components/matriculas/4/form/Matricula.vue'

export default {
  components: {
    SectionHeader, Matricula
  },
  props: {
    current: Object,
    auto: Boolean
  },
  data () {
    return {
      
    }
  },
  mounted () {

  }
}
</script>

<style>

</style>